import React, { useState, useEffect, useCallback } from "react";
import ShowSnackBar from "../components/snackBar";
import "../css/wb_developers_tools.css";
import UrlCard from "../components/UrlCard";
import { apiCall } from "../services/authServieces";
import { ClipLoader } from "react-spinners";


const WbDevelopersTools = () => {
  const [loading, setLoading] = useState(false);
  const [isAPIKey, setIsApiKey] = useState(false);
  const [apiKey, setApiKey] = useState({ apiKey: "", password: "" });
  const [snackBar, setSnackBar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      let endpoint = `api/get-api-key`;
      const response = await apiCall({ method: "GET", endpoint: endpoint });
      if (response.success) {
        if (
          response?.data?.manthan_api_key &&
          response?.data?.api_key_password
        ) {
          setIsApiKey(true);
          setApiKey({
            apiKey: response.data.manthan_api_key,
            password: response.data.api_key_password,
          });
        }
      }
    } catch (error) {
      console.log("error: ", error);
    }
    finally {
      setLoading(false);
    }
  }, []);

  const generateAPIKey = async (e) => {
    try {
      const endpoint = `api/generate-api-key`;
      const response = await apiCall({ method: "PUT", endpoint: endpoint });
      if (response.success) {
        setSnackBar({
          open: true,
          severity: true,
          message: response?.message,
        });
        await fetchData();
      }
    } catch (error) {
      setSnackBar({
        open: true,
        severity: false,
        message:
          error?.response?.data?.message ||
          "Server Error. Please try again later.",
      });
    }
  };

  const handleCloseSnackBar = (event, reason) => {
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const sesstion_rowData = '{"suggestions": [ {"suggestionType": "reply", "displayText": "Bulk SMS","postback": "Bulk SMS"},{"suggestionType": "reply","displayText": "Whtsapp SMS","postback": "Whtsapp SMS"}]}';

  return (
    <>
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
      <div className="Developers_tools_contain">
        <h4 className="Head_title">Send RCS HTTP API :</h4>
        <div className="Developers_tools_card">
          <p>
            API, An Abbreviation of Application Promgramme Interface, is a set
            pf routine, protocols and tools for building software applications.
            Whatsapp API allows application developer to integrate on there
            application and send the sms to all the numbers at one shot without
            login to their sms panel.
          </p>
          <div className="table_contain width222">
            {isAPIKey ? (
              <table className="Table">
                <thead>
                  <tr>
                    <th>API Key</th>
                    <th>API Password</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{apiKey.apiKey}</td>
                    <td>{apiKey.password}</td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <table className="Table">
                <thead>
                  <tr>
                    <th>No API Key found!</th>
                    <th>
                      <button onClick={generateAPIKey}>Generate API Key</button>
                    </th>
                  </tr>
                </thead>
              </table>
            )}
          </div>
          <div className="url_contain">

            <h4 className="cotain_title text-center">URL API :</h4>
            <div className="url_card">
              <h4>Send Text RCS URL API (WITHOUT variable):</h4>
              <p> <strong>URL</strong>: https://api.easygorcs.com/api/send-text?<strong>apiKey</strong>={apiKey.apiKey}<strong>&pass</strong>={apiKey.password}<strong>&templateId</strong>=Enter Template ID<strong>&mobile</strong>=XXXXXXXXXX</p>

            </div>

              <div className="url_card">
              <h4>Send Text RCS URL API (WITH variable):</h4>
              <p> <strong>URL</strong>: https://api.easygorcs.com/api/send-text?<strong>apiKey</strong>={apiKey.apiKey}<strong>&pass</strong>={apiKey.password}<strong>&templateId</strong>=Enter Template ID<strong>&mobile</strong>=XXXXXXXXXX<strong>&variable</strong>=sample1,sample2</p>

            </div>

          </div>

          <div className="session_url_contain">
            <h4 className="cotain_title text-center">Session API :</h4>
            <div className="url_card ">
              <h4>Send Text RCS URL API :</h4>

              <h5>Single message send URL for a template that does not contain any parameters.</h5>
              <p>
                <strong>URL</strong>: https://api.easygorcs.com/session/send_message_session_api_text_message?<strong>message</strong>=Enter your message<strong>&mobile</strong>=Enter Mobile No<strong>&apiKey</strong>={apiKey.apiKey}<strong>&pass</strong>={apiKey.password}<strong>&rowdata</strong>={sesstion_rowData}
              </p>

            </div>
          </div>




             <div className="session_url_contain">
            <h4 className="cotain_title text-center">Balance Check API :</h4>
            <div className="url_card ">
              <h4>Balance Check URL API:</h4>

              <h5>Balance Check</h5>
              <p>
                <strong>URL</strong>: https://api.easygorcs.com/api/rcs-check-balance?<strong>apiKey</strong>={apiKey.apiKey}<strong>&pass</strong>={apiKey.password}
              </p>

            </div>
          </div>





        </div>
      </div>

      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />
    </>
  );
};

export default WbDevelopersTools;
